export default "__VITE_PUBLIC_ASSET__026dd953__"